"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _trainStatus = require("../../hooks/queries/trainStatus");
var _mapState = require("../../hooks/mapState");
var _reactBootstrap = require("react-bootstrap");
var _moment = require("moment");
var _dateFns = require("date-fns");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _helpers = require("../../lib/helpers");
var _rcTooltip = _interopRequireDefault(require("rc-tooltip"));
var _sortBy = _interopRequireDefault(require("lodash/sortBy"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var TrainDrawer = function TrainDrawer(props) {
  var _trainStatus$trip_det, _trainStatus$trip_det2, _trainStatus$manuscri, _trainStatus$manuscri2, _trainStatus$consist2;
  var token = props.token;
  var _useMapState = (0, _mapState.useMapState)(),
    mapState = _useMapState.mapState,
    unselect = _useMapState.unselect;
  var selected = mapState.selected;
  // console.log('selected: ', selected)
  var _useTrainStatus = (0, _trainStatus.useTrainStatus)(selected === null || selected === void 0 ? void 0 : selected.tripShortName, token),
    isLoadingTrain = _useTrainStatus.isLoading,
    trainStatus = _useTrainStatus.data;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    staticConsist = _useState2[0],
    setStaticConsist = _useState2[1];
  // const { isLoading, data: trainStatus } = useTrainStatus(839, reduxToken)
  // console.log('its hard coded to train 210 dont forget')
  var now = new Date();
  var bikesAllowed = (trainStatus === null || trainStatus === void 0 ? void 0 : (_trainStatus$trip_det = trainStatus.trip_details) === null || _trainStatus$trip_det === void 0 ? void 0 : _trainStatus$trip_det.bikes_allowed) === '1';
  var getTimesToDisplay = function getTimesToDisplay(arrival, departure) {
    var showSeconds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (arrival === departure || !departure) {
      return (0, _helpers.formatTimestamp)(arrival, showSeconds);
    }
    if (!arrival) {
      return (0, _helpers.formatTimestamp)(departure, showSeconds);
    }
    return "".concat((0, _helpers.formatTimestamp)(arrival, showSeconds), " / ").concat((0, _helpers.formatTimestamp)(departure, showSeconds));
  };

  // console.log('static', STATIC_TRAIN_210_DATA)
  var getDeviation = function getDeviation(deviation) {
    if (deviation === 0) {
      return null;
    }
    // positive deviation represents early trains
    if (deviation > 0) {
      return /*#__PURE__*/_react["default"].createElement("strong", {
        className: 'train-early ml-2'
      }, "(".concat(deviation, ")"));
    } else if (deviation < 0) {
      return /*#__PURE__*/_react["default"].createElement("strong", {
        className: 'train-late ml-2'
      }, "(".concat(deviation, ")"));
    }
  };
  (0, _react.useEffect)(function () {
    var _trainStatus$consist;
    if (trainStatus !== null && trainStatus !== void 0 && (_trainStatus$consist = trainStatus.consist) !== null && _trainStatus$consist !== void 0 && _trainStatus$consist.makeup) {
      var justCoaches = _toConsumableArray(trainStatus.consist.makeup);
      justCoaches.reverse();
      setStaticConsist(justCoaches);
    }
  }, [trainStatus]);
  if (!(selected !== null && selected !== void 0 && selected.vehicle)) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "standalone-active-train-drawer"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "panel-header dk-blue"
    }, /*#__PURE__*/_react["default"].createElement("h2", null, "No train selected")), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Col, {
      sm: 12,
      className: "train-drawer-column"
    }));
  }
  if (isLoadingTrain) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "standalone-active-train-drawer"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "panel-header dk-blue"
    }, /*#__PURE__*/_react["default"].createElement("h2", null, "Keolis Train (", selected !== null && selected !== void 0 && selected.tripShortName ? selected.tripShortName : '', ")")), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Row, {
      className: "train-drawer-row m-0"
    }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Col, {
      sm: 12,
      className: "train-drawer-column"
    }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Row, {
      className: "justify-content-center align-items-center spinner-row"
    }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Spinner, {
      className: "loading-spinner"
    })))));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "standalone-active-train-drawer"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "panel-header dk-blue"
  }, /*#__PURE__*/_react["default"].createElement("h2", null, "Keolis Train (", selected !== null && selected !== void 0 && selected.tripShortName ? selected.tripShortName : '', ")"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "icons"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faXmark,
    size: "lg",
    onClick: function onClick() {
      unselect();
    }
  }))), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Row, {
    className: "train-drawer-row m-0"
  }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Col, {
    sm: 12,
    className: "train-drawer-column"
  }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Row, {
    className: "mb-3 ml-1"
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: "mr-3 mt-2"
  }, " ", trainStatus === null || trainStatus === void 0 ? void 0 : (_trainStatus$trip_det2 = trainStatus.trip_details) === null || _trainStatus$trip_det2 === void 0 ? void 0 : _trainStatus$trip_det2.trip_headsign), bikesAllowed && /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faBicycle,
    className: "ml-2 bicycle-icon",
    size: "lg"
  })), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Row, {
    className: "mb-3 ml-1 align-center"
  }, "Last vehicle data:", /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Badge, {
    style: {
      'line-height': 'inherit',
      'border': 'black'
    },
    pill: true,
    outline: true,
    bg: "#D0D8DF",
    className: "mr-3 ml-3 train-drawer-badge"
  }, "AEI"), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Badge, {
    style: {
      'line-height': 'inherit'
    },
    className: "train-drawer-badge",
    pill: true,
    bg: "light"
  }, "ACSES")), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Row, {
    className: "mb-3 ml-1"
  }, "Last trip data:", /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Badge, {
    style: {
      'line-height': 'inherit'
    },
    pill: true,
    bg: "light",
    className: "mr-3 ml-3 train-drawer-badge"
  }, "MBTA"), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Badge, {
    style: {
      'line-height': 'inherit'
    },
    pill: true,
    bg: "light",
    className: " mr-3 train-drawer-badge"
  }, "AMTEC"), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Badge, {
    style: {
      'line-height': 'inherit'
    },
    pill: true,
    bg: "light",
    className: "train-drawer-badge"
  }, "PIDS")), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Row, {
    className: "mb-3 ml-1"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    className: "clock-icon mr-2",
    icon: _freeSolidSvgIcons.faClock,
    size: "2x"
  }), /*#__PURE__*/_react["default"].createElement("h4", null, "Manuscript")), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Table, {
    className: "train-drawer-table"
  }, /*#__PURE__*/_react["default"].createElement("thead", {
    style: {
      position: 'sticky',
      top: 0,
      background: '#D0D8DF'
    }
  }, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", {
    className: "table-header"
  }, "Location"), /*#__PURE__*/_react["default"].createElement("th", {
    className: "table-header"
  }, "Sch Time"), /*#__PURE__*/_react["default"].createElement("th", {
    className: "table-header"
  }, "Est Time"), /*#__PURE__*/_react["default"].createElement("th", {
    className: "table-header"
  }, "Act Time"), /*#__PURE__*/_react["default"].createElement("th", {
    className: "table-header"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "noWrap"
  }, "Track (Sch : Act)")), /*#__PURE__*/_react["default"].createElement("th", {
    className: "table-header"
  }, "Transfers"))), /*#__PURE__*/_react["default"].createElement("tbody", null, !!(trainStatus !== null && trainStatus !== void 0 && (_trainStatus$manuscri = trainStatus.manuscript) !== null && _trainStatus$manuscri !== void 0 && _trainStatus$manuscri.length) && (trainStatus === null || trainStatus === void 0 ? void 0 : (_trainStatus$manuscri2 = trainStatus.manuscript) === null || _trainStatus$manuscri2 === void 0 ? void 0 : _trainStatus$manuscri2.map(function (oneStop, index) {
    var occupancyTime = new Date(oneStop.occupancy_time);
    var rowClassName = index % 2 ? 'odd-train-row' : '';
    var locationClassName = oneStop.is_public ? '' : 'nonpublic-stop-name';
    var locationSx = oneStop.is_public ? {} : {
      'text-align': 'right',
      'font-style': 'italic'
    };
    var scheduledCellContent = getTimesToDisplay(oneStop.scheduled_arrival, oneStop.scheduled_departure, false);
    var estimatedCellContent = getTimesToDisplay(oneStop.estimated_arrival, oneStop.estimated_departure);
    return /*#__PURE__*/_react["default"].createElement("tr", {
      className: rowClassName
    }, /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: locationClassName,
      style: locationSx
    }, oneStop.stop_name)), /*#__PURE__*/_react["default"].createElement("td", null, oneStop.schedule_source ? /*#__PURE__*/_react["default"].createElement(_rcTooltip["default"], {
      key: "estimated-time-".concat(scheduledCellContent),
      placement: "top",
      overlay: oneStop.schedule_source,
      arrowContent: /*#__PURE__*/_react["default"].createElement("div", {
        className: "rc-tooltip-arrow-inner"
      })
    }, /*#__PURE__*/_react["default"].createElement("span", null, scheduledCellContent)) : /*#__PURE__*/_react["default"].createElement("p", null, scheduledCellContent)), /*#__PURE__*/_react["default"].createElement("td", null, oneStop.predictions_source ? /*#__PURE__*/_react["default"].createElement(_rcTooltip["default"], {
      key: "estimated-time-".concat(estimatedCellContent),
      placement: "top",
      overlay: oneStop.predictions_source,
      arrowContent: /*#__PURE__*/_react["default"].createElement("div", {
        className: "rc-tooltip-arrow-inner"
      })
    }, /*#__PURE__*/_react["default"].createElement("span", null, estimatedCellContent)) : /*#__PURE__*/_react["default"].createElement("p", null, estimatedCellContent), getDeviation(oneStop.estimated_departure_deviation)), /*#__PURE__*/_react["default"].createElement("td", null, (0, _helpers.formatTimestamp)(oneStop.occupancy_time)), /*#__PURE__*/_react["default"].createElement("td", null, oneStop.track_source ? /*#__PURE__*/_react["default"].createElement(_rcTooltip["default"], {
      key: "track-source-".concat(oneStop.actual_track),
      placement: "top",
      overlay: oneStop.track_source,
      arrowContent: /*#__PURE__*/_react["default"].createElement("div", {
        className: "rc-tooltip-arrow-inner"
      })
    }, /*#__PURE__*/_react["default"].createElement("span", null, oneStop.scheduled_track)) : (0, _helpers.getTrackToDisplay)(oneStop.scheduled_track, oneStop.actual_track)), /*#__PURE__*/_react["default"].createElement("td", null, oneStop.transfers || ''));
  })))), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Row, {
    className: "mb-3 ml-1"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    className: "alert-icon mr-2",
    icon: _freeSolidSvgIcons.faTriangleExclamation,
    size: "2x"
  }), /*#__PURE__*/_react["default"].createElement("h4", null, "Alerts")), !!(trainStatus !== null && trainStatus !== void 0 && trainStatus.alerts.length) ? trainStatus.alerts.map(function (oneAlert) {
    var updateDate = new Date(oneAlert.updated_at);
    var lastUpdatedText = (0, _dateFns.formatDistance)(updateDate, now, {
      addSuffix: true
    });
    return /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Card, {
      className: "mb-3 train-alert-card"
    }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Card.Body, null, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Card.Text, null, oneAlert.header), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Card.Text, {
      className: "train-alert-card-footer"
    }, "Last updated ".concat(lastUpdatedText, "."), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Badge, {
      style: {
        'line-height': 'inherit'
      },
      pill: true,
      bg: "light",
      className: "mr-3 ml-3 train-drawer-badge"
    }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _freeSolidSvgIcons.faSignHanging,
      className: "sign-icon mr-2",
      size: "sm"
    }), " Sent to LED Signs"))));
  }) : /*#__PURE__*/_react["default"].createElement("p", null, "There are currently no alerts for this trip."), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Row, {
    className: "mb-3 ml-1"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faTrain,
    size: "2x",
    className: "train-icon mr-2"
  }), " ", /*#__PURE__*/_react["default"].createElement("h4", null, "Consist")), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Row, {
    className: "mb-3 ml-1"
  }, "Seating Capacity: ", trainStatus === null || trainStatus === void 0 ? void 0 : (_trainStatus$consist2 = trainStatus.consist) === null || _trainStatus$consist2 === void 0 ? void 0 : _trainStatus$consist2.capacity), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Row, {
    className: "mb-3 ml-1 flex-end consist-row"
  }, !!staticConsist.length && staticConsist.map(function (oneCoach) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "mr-1 rail-coach-icon-".concat(oneCoach.type.toLowerCase().replace('r', ''))
    }, oneCoach.label, oneCoach.type.toLowerCase().includes('r') && /*#__PURE__*/_react["default"].createElement("div", {
      className: "train-alert-card-footer toilet-div-".concat(oneCoach.type.toLowerCase().replace('r', ''))
    }, "Toilet")));
  })))));
};
var _default = TrainDrawer;
exports["default"] = _default;